import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../table";
import { columns, paymentColumn } from "./columns";
import { dateStandard } from '../../shared/dateFunction'
import "./style.css";

const TableTabGroup = (props) => {

    // console.log(props);
    const navigate = useNavigate()

    const handleSort = (sort) => {
        let _allFilter = { ...props.viewOrder.filters };
        _allFilter.sort = sort;
        props.updateFilters(_allFilter);
        //console.log(_allFilter);
    };

    const getRows = () => {
        let _rows = []
        let data = props.tabs.filter((f) => f.key == props.activeTab)
        if (data.length) {
            data[0].data.forEach((d, i) => {
                // console.log((d));
                if(props.activeTab === 'PAYMENT') 
                {
                    _rows.push({
                        id: i + 1 + (props.page[props.activeTab]),
                        aadhar: d.aadhar,
                        date: d.date,
                        name: d.name,
                        subName:d.subName,
                        orderId:d.orderId,
                        paymentStatus:d.payment_status,
                        transactionAmount:d.trnAmt,
                        transactionReferenceNumber:d.pgMeTrnRefNo,
                        paymentDate:dateStandard(d.created)
                    })
                }else{
                    _rows.push({
                        id: i + 1 + (props.page[props.activeTab]),
                        name: d.name,
                        email: d.email,
                        mobile: d.mobile,
                        aadhar: d.aadhar,
                        date: dateStandard(d.date),
                        docUploadDate: dateStandard(d.doc_uploaded_time),
                        // view: <button onClick={() => navigate("/form-details/" + d.id)} className="btn btn-primary">View</button>
                        view: <Link to={ "/form-details/" + d.id } className="btn btn-primary" target="_blank">View</Link>
    
                    })
                }
               
            })
        }
        return _rows;
    }

    const getPageNo = () => {
        return props.page[props.activeTab] / 50 + 1
    }

    const getTotal = () => {
        let data = props.tabs.filter((f) => f.key == props.activeTab)
        if (data.length) {
            console.log(data[0].total / 50 + 1);
            return parseInt(data[0].total / 50) + 1
        }
        return 0
    }

    return (
        <>
            <div className="tab-table-container card">
                <div className="tab-group">
                    {props.tabs.map((tab, index) => (
                        <div
                            key={index}
                            className={`tab ${props.activeTab === tab.key ? "selected" : ""}`}
                            onClick={() => props.handleTabClick(tab.key)}
                        >
                            {tab.label}
                        </div>
                    ))}
                </div>

                <Table
                    rows={getRows()}
                    columns={props?.activeTab === 'PAYMENT'? paymentColumn : columns}
                    handleSort={handleSort}
                    // sort={props.viewOrder.filters.sort}
                    pageNo={getPageNo()}
                    total={getTotal()}
                    handlePage={(e, p) => props.updatePage(e, p, props.activeTab)}
                />
            </div>
        </>
    );
};

export default TableTabGroup;
